import * as React from 'react';
import { useField } from 'formik';

import GrayBlob from 'src/assets/img/pricing/gray-blob.svg';
import BlueBlob from 'src/assets/img/pricing/blue-blob.svg';
import OrangeBlob from 'src/assets/img/pricing/orange-blob.svg';
import GreenBlob from 'src/assets/img/pricing/green-blob.svg';

import GrayBlobMobile from 'src/assets/img/mobile/pricing-blob-bg.svg';

import { TryItButton } from '../TryItButton';
import { CURRENCY_SYMBOLS } from '../../constants';
import { CurrencyType } from '../../types';

export const PricingBlock = () => {
  const [field] = useField<{ id: CurrencyType }>('currency');

  const currencySymbol = CURRENCY_SYMBOLS[field.value.id];

  return (
    <div className="price-block">
      {/* <div className="billing-info">
        <div className="text-block">
          <div className="price">{currencySymbol}18</div>
          <div className="sub-title">Billed monthly</div>
          <TryItButton/>
        </div>

        <img src={BlueBlob} alt="BlueBlob"/>
      </div> */}
      <div className="billing-info right">
        <div className="text-block">
          <div className="sub-title">Only</div>
          <div className="price">{currencySymbol}295</div>
          <div className="sub-title">Per Year</div>
          {/* <div className="info">({currencySymbol}15 per month)</div> */}
          {/* <div className="sub-title">Billed annually</div> */}
          <TryItButton/>
        </div>

        <img src={GreenBlob} alt="GreenBlob"/>
      </div>

      {/* <div className="discount-block">
        <div className="discount">
          <div>SAVE</div>
          <div className="percents">17%</div>
        </div>

        <img src={OrangeBlob} alt="OrangeBlob"/>
      </div> */}

      <img className="gray-blob hide-mobile" src={GrayBlob} alt="GrayBlob"/>
      <img className="gray-blob hide-desktop" src={GrayBlobMobile} alt="GrayBlobMobile"/>
    </div>
  );
};
